<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Betaler - G4 kontoinfo.</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<div mat-dialog-content>
  <p>Kundenr.: {{ kunde.okKundeNr }}</p>
  <p>
    {{ kunde?.kontoAdresse?.name }}
    <br />
    {{ kunde?.kontoAdresse?.adressLine }}
  </p>
  <p>
    @if (kunde?.anlaegsadresse?.phone) {
      <span>
        T: {{ $safeNavigationMigration(kunde?.anlaegsadresse?.phone) | dkPhoneNumber }}
        <br />
      </span>
    }
    @if (kunde?.anlaegsadresse?.mobile) {
      <span>
        M: {{ $safeNavigationMigration(kunde?.anlaegsadresse?.mobile) | dkPhoneNumber }}
        <br />
      </span>
    }
    <a href="mailto:{{ kunde?.anlaegsadresse?.email }}" class="ellipsis" title="Send mail til {{ kunde?.anlaegsadresse?.email }}">
      {{ kunde?.anlaegsadresse?.email }}
    </a>
  </p>
</div>
<div mat-dialog-actions class="row-reverse">
  <button mat-raised-button color="primary" mat-dialog-close>Luk</button>
</div>
